import person from "../../assets/imgs/persons/confusedMale.png";
import { Button, useTheme } from "@mui/material";

export default function ConfusedMale({
  mainFill,
  primaryCircleFill,
  highlightTitle,
  subtitle,
  highlightSubtitle,
  buttonName = "",
  functionButton = () => {},
}) {
  const theme = useTheme();
  return (
    <div style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
      <svg
        width="627"
        height="570"
        viewBox="0 0 627 570"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: "100%", height: "auto", display: "block" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M382.45 445.928C449.157 433.09 535.615 470.784 576.054 414.653C617.05 357.749 585.816 272.197 554.949 206.493C528.319 149.809 478.462 110.317 422.306 87.3843C372.961 67.233 322.591 81.5042 271.173 90.6069C207.79 101.828 133.691 93.5819 93.8864 145.526C49.4664 203.493 36.3141 289.792 64.724 360.018C91.8566 427.088 162.549 463.143 229.725 481.307C282.95 495.698 329.086 456.199 382.45 445.928Z"
          fill={mainFill}
        />
        <circle cx="444" cy="345.489" r="100" fill={primaryCircleFill} />
        <rect
          x="232"
          y="181.489"
          width="394"
          height="264"
          fill="url(#pattern0_998_3304)"
        />

        {/* TEXTO DENTRO DO SVG */}
        <text
          x="110"
          y="220"
          fill={theme.palette.primary.main}
          fontWeight="700"
          fontSize="36"
        >
          {highlightTitle}
        </text>
        <text
          x="110"
          y="250"
          fill={theme.palette.white.main}
          fontWeight="400"
          fontSize="20"
        >
          {subtitle?.split("\n").map((line, i) => (
            <tspan key={i} x="110" dy={i === 0 ? 0 : 24}>
              {line}
            </tspan>
          ))}
        </text>
        <text
          x="110"
          y="295"
          fill={theme.palette.primary.lighter}
          fontWeight="500"
          fontSize="16"
        >
          {highlightSubtitle}
        </text>

        {/* BOTÃO RESPONSIVO DENTRO DO viewBox DO SVG */}
        {buttonName && (
          <foreignObject x="110" y="325" width="200" height="50">
            <Button
              variant="contained"
              color="primary"
              style={{ width: "max-content" }}
              onClick={functionButton}
            >
              {buttonName}
            </Button>
          </foreignObject>
        )}

        <defs>
          <pattern
            id="pattern0_998_3304"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlinkHref="#image0_998_3304"
              transform="matrix(0.000656825 0 0 0.000980262 -0.000634518 0)"
            />
          </pattern>
          <image
            id="image0_998_3304"
            width="1536"
            height="1024"
            preserveAspectRatio="none"
            href={person}
          />
        </defs>
      </svg>
    </div>
  );
}
